<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="70%"
    top="5vh"
    class="add-contacts-modal"
    @close="onClose"
  >
    <el-row slot="title" type="flex" justify="space-between" align="middle">
      <h2>ДОБАВЛЕНИЕ КОНТАКТОВ</h2>
      <b>
        <el-button type="text" class="close-btn" @click="onBack">
          <b>звонить</b>
        </el-button>
      </b>
    </el-row>
    <el-row>
      <p>Телефоны (новый телефон на новой строке)</p>
      <el-input v-model="textarea" :rows="13" type="textarea" />
    </el-row>
    <el-row class="btn-block ta-r">
      <el-button type="primary" :loading="loading" @click="onAdd">
        Добавить
      </el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { UPDATE_TASK } from '@/store/actions/callCenter'
import { mapGetters, mapMutations } from 'vuex'
import { preparePhone } from '@/helpers/functions'

const CallCenter = RepositoryFactory.get('callCenter')

export default {
  name: 'AddContactsModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      textarea: '',
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ getTask: 'callCenter/getList' }),
    total() {
      const { stats } = this.getTask('tasks', this.id)

      return stats ? stats.total : 0
    },
  },
  methods: {
    ...mapMutations({ updateTask: `callCenter/${UPDATE_TASK}` }),
    onAdd() {
      const { id, textarea, total } = this
      const phone_numbers = this.check(textarea)

      if (phone_numbers) {
        this.loading = true
        CallCenter.addContactsToTask(id, { phone_numbers })
          .then(res => {
            const { status, data } = res

            if (status === 200 && data) {
              const { stats } = data

              this.updateTask(data)
              this.openAlert(stats.total - total)
            }
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      }
    },
    openAlert(n) {
      this.$alert(`${n} контактов добавлены успешно`, '', {
        confirmButtonText: 'OK',
        showClose: false,
        center: true,
        customClass: 'alert-add-message',
        callback: () => (this.textarea = ''),
      })
    },
    check(text) {
      const res = text ? text.trim() : ''
      let numbers = ''

      if (res && res.length) {
        const arr = res.split('\n')

        numbers = arr.map(n => preparePhone(n)).join(',')
      }

      return numbers
    },
    onBack() {
      this.onClose()
      this.$emit('set', 'contactsModal', this.id)
    },
    onClose() {
      this.textarea = ''
      this.$emit('set', 'addContactModal')
    },
  },
}
</script>

<style lang="sass">
.add-contacts-modal
  h2
    margin: 30px
    font-weight: bold
    font-size: 18px
    line-height: 17px
  .close-btn
    margin-right: 30px
    text-decoration: underline
  .el-textarea__inner, .el-button
    font-size: 16px
    font-family: Rubik, sans-serif
  .el-dialog__body
    padding: 0 50px 50px
    p
      font-size: 18px
      line-height: 17px
      color: #000
    .btn-block
      margin-top: 100px
      button
        width: 300px
        height: 47px
        font-weight: normal
.alert-add-message
  .el-message-box__message
    font-weight: bold
    font-size: 16px
    font-family: Rubik, sans-serif
    margin: 50px auto
    color: #000
  button
    width: 200px
    height: 47px
    font-size: 16px
    font-family: Rubik, sans-serif
    font-weight: normal
</style>
